<div class="animated fadeIn">
  <div class="row">
    <div class="col-md-12 mb-4">
      <tabset>
        <tab heading="Bug Reports">
          <div class="row">
            <div class="col-lg-12">
      <div class="card">
        <div class="card-header">
          <i class="fa fa-bug"></i> Bug Reports
        </div>
        <div class="card-body">
          <table class="table table-responsive-sm table-hover table-outline mb-0">
            <thead class="thead-light">
              <tr>
                <th>#</th>
                <th>User</th>
                <th>Type</th>
                <th>Rate</th>
                <th>Version</th>
                <th>Date</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              @if (isLoading) {
                <tr>
                  <td colspan="8" class="text-center">
                    <span class="spinner-border spinner-border-sm"></span> Loading...
                  </td>
                </tr>
              } @else if (reports.length === 0) {
                <tr>
                  <td colspan="8" class="text-center text-muted">No bug reports found.</td>
                </tr>
              } @else {
                @for (report of reports; track report.bugReportId; let i = $index) {
                  <tr>
                    <td>{{ (pageNumber - 1) * resultsPerPage + i + 1 }}</td>
                    <td>
                      <svg cIcon [name]="getLocaleFlagIconName(report.userLocale)" [tooltip]="report.userLocale" placement="top" class="me-1" style="width:22px; height:16px;"></svg>
                      {{ getDisplayName(report) }}
                    </td>
                    <td>{{ getBugTypeName(report.bugType) }}</td>
                    <td>
                      @for (star of [1,2,3,4,5]; track star) {
                        <i class="fa" [class.fa-star]="star <= report.rate" [class.fa-star-o]="star > report.rate" style="color: #f5a623;"></i>
                      }
                    </td>
                    <td>{{ report.applicationVersion ?? '-' }}</td>
                    <td>{{ dateService.getDateFromatted(report.createdAtTimestamp) }}</td>
                    <td>
                      @if (report.isClosed) {
                        <span class="badge bg-danger">Closed</span>
                      } @else {
                        <span class="badge bg-success">Open</span>
                      }
                      @if (report.shopBuyCredits && report.shopBuyCredits > 0) {
                        <span class="badge bg-warning text-dark ms-1" [tooltip]="report.shopBuyCredits + ' credits'" placement="top">VIP</span>
                      }
                    </td>
                    <td>
                      <button class="btn btn-sm btn-info me-1" type="button" (click)="onClickDetails(report)" tooltip="Details" placement="top">
                        <i class="fa fa-eye"></i>
                      </button>
                      <a class="btn btn-sm btn-primary me-1"
                         routerLink="/backoffice/management/user-details"
                         [queryParams]="{ id: report.userId }"
                         target="_blank"
                         tooltip="User details"
                         placement="top">
                        <i class="fa fa-user"></i>
                      </a>
                      <button class="btn btn-sm btn-warning me-1"
                              type="button"
                              (click)="onClickLastMatch(report)"
                              [disabled]="!report.lastMatchId"
                              tooltip="Last match details"
                              placement="top">
                        <i class="fa fa-gamepad"></i>
                      </button>
                      <button class="btn btn-sm btn-secondary me-1" type="button" (click)="onClickSendMessage(report)" tooltip="Send Message" placement="top">
                        <i class="fa fa-envelope"></i>
                      </button>
                      <button
                        class="btn btn-sm"
                        [class.btn-success]="report.isClosed"
                        [class.btn-danger]="!report.isClosed"
                        type="button"
                        (click)="onClickToggleState(report)"
                        [tooltip]="report.isClosed ? 'Reopen' : 'Close'"
                        placement="top">
                        <i class="fa" [class.fa-lock-open]="report.isClosed" [class.fa-lock]="!report.isClosed"></i>
                        {{ report.isClosed ? 'Reopen' : 'Close' }}
                      </button>
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
          <br/>
          <div class="d-flex justify-content-between align-items-center">
            <small class="text-muted">
              Showing {{ (pageNumber - 1) * resultsPerPage + 1 }} to {{ (pageNumber - 1) * resultsPerPage + reports.length }} of {{ totalResults }} entries
            </small>
            <ul class="pagination pagination-sm mb-0">
              <li class="page-item" [class.disabled]="pageNumber <= 1">
                <button class="page-link" (click)="onClickPaginationPrevious()" [disabled]="pageNumber <= 1">&laquo;</button>
              </li>
              @for (page of getPageNumbers(pageNumber, totalPages); track $index) {
                @if (page === null) {
                  <li class="page-item disabled"><span class="page-link">...</span></li>
                } @else {
                  <li class="page-item" [class.active]="page === pageNumber">
                    <button class="page-link" (click)="goToPage(page)">{{ page }}</button>
                  </li>
                }
              }
              <li class="page-item" [class.disabled]="pageNumber >= totalPages">
                <button class="page-link" (click)="onClickPaginationNext()" [disabled]="pageNumber >= totalPages">&raquo;</button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
        </tab>
        <tab heading="Configurations">
          <app-configurations-block [configurations]="bugReportsConfigurations" [collapsible]="false" />
        </tab>
      </tabset>
    </div>
  </div>
</div>

<app-bug-report-detail-modal #detailModal></app-bug-report-detail-modal>
<app-news-user-add-modal #newsUserAddModal></app-news-user-add-modal>
<app-user-match-detail-modal #matchDetailModal></app-user-match-detail-modal>
